/// <reference path="../../Common/Helpers/GridEditorDialog.ts" />

namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class FranchiseeOrderProductsEditDialog extends Common.GridEditorDialog<OrderProductsRow> {
        protected getFormKey() { return FranchiseeOrderProductsForm.formKey; }
        protected getLocalTextPrefix() { return OrderProductsRow.localTextPrefix; }

        protected form = new FranchiseeOrderProductsForm(this.idPrefix);
        public stateIds: number;
        public FranchiseeId: number;
        public OrderStatus: number;
        constructor() {
            super();           
            //this.form.Quantity.changeSelect2(e => {
            //    var productId = this.form.ProductId.value.toString();
            //    var ProductSpecificationId = this.form.ProductSpecificationId.value;
            //    var stateIds = this.stateIds;
            //    debugger;
            //    if (this.isNew() == false) {
            //        Q.confirm('Are you sure you want to change Quantity,This will update Order and its Invoice?', () => {

                      
            //        });
            //    }
               



            //});
            //this.form.DiscountAmt.changeSelect2(e => {
            //    Q.confirm('Are you sure you want to change Discount,This will update Order and its Invoice?', () => {

            //    });


            //});
        }

        private seEntityDetails(totalTaxRate: number) {
            
            if (this.form.Quantity.value == null) {
                this.form.Quantity.value = 1;
            }
          //  this.form.TaxAmount.value = this.form.Amount.value * totalTaxRate / 100;

            //  this.form.Amount.value = this.form.Quantity.value * this.form.Cost.value;

        }
        
       
        //protected validateBeforeSave() {
        //    var isValidate = super.validateForm();
        //    if (isValidate) {
        //        isValidate = super.validateBeforeSave();
        //    }
           
        //    return isValidate;
        //}

        loadEntity(entity: OrderProductsRow) {
            super.loadEntity(entity);
            //debugger;
            if (this.isNew) {
                this.form.FranchiseeId.value = this.FranchiseeId.toString();
            }
            else {
               
                Serenity.EditorUtils.setReadonly(this.form.FranchiseeId.element, true);
            }
            if (this.form.OrderId.value != "") {
                Serenity.EditorUtils.setReadonly(this.form.ProductId.element, true);
                Serenity.EditorUtils.setReadonly(this.form.OrderProductSpecificationId.element, true);
                Serenity.EditorUtils.setReadonly(this.form.DiscountAmt.element, true);
                Serenity.EditorUtils.setReadonly(this.form.Quantity.element, true);
                Serenity.EditorUtils.setReadonly(this.form.SerialKey.element, true);
                Serenity.EditorUtils.setReadonly(this.form.Note.element, true);
            }
          
        }

        protected updateInterface(): void {

            super.updateInterface();
            //if (this.isEditMode) {
            //    Serenity.EditorUtils.setReadonly(this.form.ProductId.element, true);
            //    Serenity.EditorUtils.setReadonly(this.form.OrderProductSpecificationId.element, true);
            //    Serenity.EditorUtils.setReadonly(this.form.DiscountAmt.element, true);
            //}
        }

    }
}